module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/5_4258fc89b19dd28514b20135d6553791.png";